module.exports = __webpack_public_path__ + "static/img/throttleProBg-3.d86118e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/throttleProBg-3.png
// module id = djBR
// module chunks = 1